export const ConnectionPathTopLeftAnimated = () => (
  <svg
    width="21"
    height="342"
    viewBox="0 0 21 342"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="left-top">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V221.185C0 230.439 5.98555 238.295 14.2963 241.093C5.98555 243.89 0 251.746 0 261V321C0 332.598 9.40202 342 21 342V340C10.5066 340 2 331.493 2 321V261C2 251.16 9.48009 243.067 19.0643 242.097C19.7017 242.156 20.3474 242.185 21 242.185V242V240.185V240C20.3474 240 19.7017 240.03 19.0643 240.088C9.48008 239.118 2 231.025 2 221.185V0H0Z"
        fill="#D4CCD7"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V221.185C0 230.439 5.98555 238.295 14.2963 241.093C5.98555 243.89 0 251.746 0 261V321C0 332.598 9.40202 342 21 342V340C10.5066 340 2 331.493 2 321V261C2 251.16 9.48009 243.067 19.0643 242.097C19.7017 242.156 20.3474 242.185 21 242.185V242V240.185V240C20.3474 240 19.7017 240.03 19.0643 240.088C9.48008 239.118 2 231.025 2 221.185V0H0Z"
      fill="#D4CCD7"
    />
    <rect width="70" height="81" fill="url(#paint1)" mask="url(#left-top)">
      <animate
        attributeName="y"
        begin="2.5s"
        from="-80"
        to="400"
        dur="5s"
        repeatCount="indefinite"
      />
    </rect>

    <defs>
      <linearGradient
        id="paint1"
        x1="35"
        y1="0"
        x2="35"
        y2="400"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A293FF" />
        <stop offset="0.9999" stopColor="#FE588B" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectionPathTopRightAnimated = () => (
  <svg
    width="21"
    height="342"
    viewBox="0 0 21 342"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="right-top">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 0V221.185C21 230.439 15.0145 238.295 6.7037 241.093C15.0145 243.89 21 251.746 21 261V321C21 332.598 11.598 342 0 342V340C10.4934 340 19 331.493 19 321V261C19 251.16 11.5199 243.067 1.93574 242.097C1.2983 242.156 0.652628 242.185 0 242.185V242V240.185V240C0.652628 240 1.2983 240.03 1.93574 240.088C11.5199 239.118 19 231.025 19 221.185V0H21Z"
        fill="#fff"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 0V221.185C21 230.439 15.0145 238.295 6.7037 241.093C15.0145 243.89 21 251.746 21 261V321C21 332.598 11.598 342 0 342V340C10.4934 340 19 331.493 19 321V261C19 251.16 11.5199 243.067 1.93574 242.097C1.2983 242.156 0.652628 242.185 0 242.185V242V240.185V240C0.652628 240 1.2983 240.03 1.93574 240.088C11.5199 239.118 19 231.025 19 221.185V0H21Z"
      fill="#D4CCD7"
    />

    <rect width="70" height="81" fill="url(#paint2)" mask="url(#right-top)">
      <animate
        attributeName="y"
        from="-80"
        to="400"
        dur="5s"
        repeatCount="indefinite"
      />
    </rect>
    <defs>
      <linearGradient
        id="paint2"
        x1="35"
        y1="0"
        x2="35"
        y2="400"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A293FF" />
        <stop offset="0.9999" stopColor="#FE588B" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectionPathTopMiddleAnimated = () => (
  <svg
    width="2"
    height="199"
    viewBox="0 0 2 199"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="center-top">
      <path d="M1 0V198.5" stroke="#fff" strokeWidth="2" />
    </mask>
    <path d="M1 0V198.5" stroke="#D4CCD7" strokeWidth="2" />
    <rect width="70" height="81" fill="url(#paint3)" mask="url(#center-top)">
      <animate
        attributeName="y"
        from="-80"
        begin="7s"
        to="400"
        dur="5s"
        repeatCount="indefinite"
      />
    </rect>
    <defs>
      <linearGradient
        id="paint3"
        x1="35"
        y1="0"
        x2="35"
        y2="400"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A293FF" />
        <stop offset="0.9999" stopColor="#FE588B" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectionPathBottomRightAnimated = () => (
  <svg
    width="117"
    height="210"
    viewBox="0 0 117 210"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="bottom-right">
      <path
        d="M1 0V0C1 16.0933 14.0462 29.1394 30.1394 29.1394H66C93.6142 29.1394 116 51.5252 116 79.1394L116 166.547C116 189.993 96.993 209 73.5467 209V209"
        stroke="#D4CCD7"
        strokeWidth="2"
      />
    </mask>
    <path
      d="M1 0V0C1 16.0933 14.0462 29.1394 30.1394 29.1394H66C93.6142 29.1394 116 51.5252 116 79.1394L116 166.547C116 189.993 96.993 209 73.5467 209V209"
      stroke="#D4CCD7"
      strokeWidth="2"
    />

    <rect width="200" height="81" fill="url(#paint4)" mask="url(#bottom-right)">
      <animate
        attributeName="y"
        from="-80"
        begin="5s"
        to="400"
        dur="6s"
        repeatCount="indefinite"
      />
    </rect>
    <defs>
      <linearGradient
        id="paint4"
        x1="35"
        y1="0"
        x2="35"
        y2="300"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A293FF" />
        <stop offset="0.9999" stopColor="#FE588B" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
)

export const ConnectionPathBottomLeftAnimated = () => (
  <svg
    width="117"
    height="210"
    viewBox="0 0 117 210"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M116 0V0C116 16.0933 102.954 29.1394 86.8606 29.1394H51C23.3858 29.1394 0.999993 51.5252 0.999994 79.1394L0.999997 166.547C0.999998 189.993 20.007 209 43.4533 209V209"
      stroke="#D4CCD7"
      strokeWidth="2"
      strokeDasharray="2 4"
    >
      <animate
        attributeName="stroke-dashoffset"
        values="-100;0"
        dur="15s"
        calcMode="linear"
        repeatCount="indefinite"
      />
    </path>
  </svg>
)
